<div
  [tabindex]="editable() ? 0 : -1"
  [ngClass]="{
    focusable: editable(),
    focused: isDialogOpen,
    invalid: !stateService.isAValidState && editable(),
    disabled: !editable(),
    hoverable: !isClearFilterEnabled(),
    'has-value': displayValueSet,
  }"
  #wrapper
  class="miq-quarter-selector-wrapper"
  >
  <div [class.editable]="editable()" (click)="onElementClick()" class="miq-quarter-selector">
    @if (!displayValueSet) {
      <div class="placeholder">{{ placeholder() }}</div>
    }
    @if (displayValueSet) {
      <div class="value">{{ displayValue }}</div>
    }
    @if (displayClearButton()) {
      <em class="periodrange-clear pi pi-times-circle" (click)="clearFilter()"></em>
    }
    <mat-icon svgIcon="calender-icon" class="calender-icon"></mat-icon>
  </div>
</div>
